"use client";

import type { FC } from "react";
import { type PractitionerType as PractitionerTypeValue, type TaxonomyOption } from "cmw-client";
import { cn } from "@/lib/cn";
import { PRACTITIONER_TYPE_LABELS } from "@/components/practitioner-card/labels";
import { DefinitionTag } from "./definition-tag";
import { PRACTITIONER_TYPE_DEFINITIONS_DRAFT, endorsementDefinitionDraft } from "./practitioner-type-definitions";

export type PractitionerTypeProps = {
  type: PractitionerTypeValue;
  endorsements?: TaxonomyOption[];
  className?: string;
};

export const PractitionerType: FC<PractitionerTypeProps> = ({ type, endorsements = [], className }) => (
  <span className={cn("text-14 text-neutral-black", className)}>
    <DefinitionTag
      label={PRACTITIONER_TYPE_LABELS[type] ?? type}
      definition={PRACTITIONER_TYPE_DEFINITIONS_DRAFT[type]}
    />
    {endorsements.map((endorsement) => (
      <span key={endorsement.slug}>
        {", "}
        <DefinitionTag label={endorsement.label} definition={endorsementDefinitionDraft(endorsement.slug)} />
      </span>
    ))}
  </span>
);
